import { render, staticRenderFns } from "./detailTitle.vue?vue&type=template&id=0c50f93c&scoped=true&"
import script from "./detailTitle.vue?vue&type=script&lang=js&"
export * from "./detailTitle.vue?vue&type=script&lang=js&"
import style0 from "./detailTitle.vue?vue&type=style&index=0&id=0c50f93c&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c50f93c",
  null
  
)

export default component.exports